import { components } from '@/utils'

import button from '@/components/button'

function renderText(h, { text }) {
  if (text) {
    return h(
      'div',
      {
        class: `${components.snackbar}__item-text`
      },
      [ text ]
    )
  }
}

function renderButton(h, item) {
  if (item.button && item.button.on) {
    return h(
      button,
      {
        class: item.button.class,
        props: this.getItemButtonProps(item),
        on: { click: item.button.on.click }
      }
    )
  }
}

function renderCancelable(h, { cancelable, remove }) {
  if (cancelable) {
    return h(
      button,
      {
        class: `${components.snackbar}__item-button-close`,
        props: this.closeButtonProps,
        on: { click: remove }
      }
    )
  }
}
function renderButtons(h, item) {
  const buttons = [
    renderButton.call(this, h, item),
    renderCancelable.call(this, h, item)
  ].filter(Boolean)

  if (buttons.length) {
    return h(
      'div',
      {
        class: `${components.snackbar}__item-buttons`
      },
      buttons
    )
  }
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${components.snackbar}__item ${components.snackbar}__item--${item.type}`,
      key: item.id,
      on: {
        mouseenter: item.pause,
        mouseleave: item.resume
      }
    },
    [
      renderText.call(this, h, item),
      renderButtons.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return this.items.map(item => {
    return renderItem.call(this, h, item)
  })
}

export default function(h) {
  return h(
    'transition-group',
    {
      class: components.snackbar,
      props: this.transitionGroupProps
    },
    [ renderItems.call(this, h) ]
  )
}
